import styled from 'styled-components';

export const ContainerWrapper = styled.div``;

export const ToolBar = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  max-width: 1280px;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing[4]}px ${theme.spacing[6]}px`};
  gap: ${({ theme }) => theme.spacing[6]}px;
`;

export const ContainerUsuarioDeslogado = styled.div``;

export const ContainerAutenticacao = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const Coluna = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Linha = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[1]}px;
`;

export const ContainerBotaoPaginasUsuario = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing[2]}px ${theme.spacing[3]}`};
  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const ContainerSearchField = styled.div`
  flex: 1;
`;
